import { axiosRequestGET } from './serviceConfig';

export const getLanguagesService = () => axiosRequestGET('/api/localization/languages/current-locale');
